// src/hooks/useLogin.js
import { useState, useEffect, useCallback } from "react";

export function useLogin() {


    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [user, setUser] = useState(null);


  // Adiciona um estado de 'carregando' para evitar piscar a tela
  const [isLoading, setIsLoading] = useState(true); 

  useEffect(() => {
    const token = localStorage.getItem("authToken") || sessionStorage.getItem("authToken");
    const savedUser = localStorage.getItem("authUser") || sessionStorage.getItem("authUser");

    if (token && savedUser) {
      try {
        setIsLoggedIn(true);
        setUser(JSON.parse(savedUser));
      } catch {
        localStorage.removeItem("authToken");
        localStorage.removeItem("authUser");
        sessionStorage.removeItem("authToken");
        sessionStorage.removeItem("authUser");
      }
    }

    setIsLoading(false);
  }, []);

  const login = useCallback((userData) => {
    // O LoginForm já salvou no localStorage
    setIsLoggedIn(true);
    setUser(userData);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("authUser");
    sessionStorage.removeItem("authToken");
    sessionStorage.removeItem("authUser");
    setIsLoggedIn(false);
    setUser(null);
  }, []);

  // Retorna o isLoading para o App.js poder exibir um "Carregando..."
  return { isLoggedIn, user, login, logout, isLoading }; 
}